module.exports = __webpack_public_path__ + "img/IAAI.80241199.jpeg";